module.exports = __webpack_public_path__ + "static/media/cue.0dca238e.svg";